import { render, staticRenderFns } from "./List-shipment-Origin.vue?vue&type=template&id=1bf00048&scoped=true"
import script from "./List-shipment-Origin.vue?vue&type=script&lang=js"
export * from "./List-shipment-Origin.vue?vue&type=script&lang=js"
import style0 from "./List-shipment-Origin.vue?vue&type=style&index=0&id=1bf00048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf00048",
  null
  
)

export default component.exports